import React from 'react';
import { Breadcrumb, Layout, notification, Modal } from 'antd/lib';
import * as Icons from '@ant-design/icons';

import { graphql, withApollo } from 'react-apollo';

import Loading from '../../../common/Loading';

import FormArticulo from './FormArticulo';

import getArticulos from '../../../../graphql/querys/articulos/getArticulos.graphql';
import insertArticulo from '../../../../graphql/mutations/articulos/insertArticulo.graphql';
import { errorService } from '../../../../graphql/utils/utils';

const estiloContent = {
  marginTop: 16,
  border: '1px dashed #e9e9e9',
  borderRadius: 6,
  backgroundColor: '#fafafa',
  paddingTop: 20,
};

@graphql(insertArticulo, {
  name: 'insertArticulo',
  options: {
    refetchQueries: [{ query: getArticulos }],
  },
})
class CrearArticulo extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      articulo: {
        nombre: '',
        descripcion: '',
      },
      step: 0,
      loading: false,
    };

    this.guardarArticulo = this.guardarArticulo.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  guardarArticulo(articulo) {
    this.props
      .insertArticulo({
        variables: {
          articulo,
        },
      })
      // eslint-disable-next-line no-unused-vars
      .then(res => {
        notification.success({
          message: 'Creacion Correcta',
          description: 'Se ha registrado la nueva articulo exitosamente',
        });

        this.props.history.push('/admin/otros/articulos');
      })
      .catch(err => {
        console.log('Error en la creacion de la articulo');
        console.log(err);
        errorService(err, articulo);
        Modal.error({
          title: 'Error en la inicializacion del componente grafico',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });
  }

  onCancel() {
    this.setState({
      fase: 0,
    });
  }

  render() {
    if (this.state.loading) {
      return <Loading />;
    }

    return (
      <div>
        <Breadcrumb
          style={{
            margin: '12px 0',
          }}
        >
          <Breadcrumb.Item>Articulo</Breadcrumb.Item>
          <Breadcrumb.Item>Crear</Breadcrumb.Item>
        </Breadcrumb>
        <Layout
          style={{
            background: '#fff',
            padding: 24,
            minHeight: '80vh',
          }}
        >
          <h2 style={{ marginBottom: 10, textAlign: 'center' }}>
            <Icons.FileTextOutlined /> Crear Articulo
          </h2>
          <br />
          <div style={estiloContent}>
            <FormArticulo
              className="formularios"
              onSubmit={this.guardarArticulo}
              onAnterior={() =>
                this.props.history.push('/admin/otros/articulos')
              }
              datos={this.state.articulo}
            />
          </div>
        </Layout>
      </div>
    );
  }
}

export default withApollo(CrearArticulo);
